import { Button, Box, Typography, makeStyles } from "@material-ui/core";
import { particlesOptions } from "./util";
import cypressLogo from "../../assets/cypressLogo.png";
import Particles from "react-tsparticles";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  Container: {
    position: "absolute",
    height: "520px",
    width: " 400px",
    borderRadius: " 30px",
    boxShadow: "1px 1px 4px 2px rgba(0, 0, 0, 0.1)",
    transform: " translate(-50%, -50%)",
    top: "50%",
    left: "50%",
  },
  ContentHeader: {
    padding: "30px",
    display: "flex",
    flexDirection: "column",
  },
  ContentLogos: {
    padding: "30px",
    fontSize: "3em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "15px",
  },
  Title: {
    fontSize: "2em",
    textAlign: "center",
    paddingBottom: "5px",
    color: " #000",
  },
  SubTitle: {
    fontSize: "0.9em",
    textAlign: "center",
    color: "#000",
  },
  ContentMain: {
    padding: "30px",
  },
}));
export const Home = () => {
  const classes = useStyles();
  return (
    <>
      <Particles id="tsparticles" options={particlesOptions} />
      <Box className={classes.Container}>
        <Box className={classes.ContentHeader}>
          <Box className={classes.ContentLogos}>
            <img src={cypressLogo} alt="cypressLogo" width={90} height={90} />
          </Box>
          <Typography className={classes.Title}>
            Mentoria de Automação
          </Typography>
          <Typography className={classes.SubTitle}>
            Quer dar um Up em sua carreira e conhecer ainda mais sobre a
            ferramenta de Automação Web em Cypress? Então, vamos iniciar os
            testes!
          </Typography>
        </Box>
        <Box className={classes.ContentMain}>
          <Link to="/formulario">
            <Button fullWidth color="primary" variant="contained">
              Iniciar agora
            </Button>
          </Link>
        </Box>
      </Box>
    </>
  );
};
